/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { translationKeys, useTranslation } from "./../../Internationalisierung/i18nBasis";
import animation from "./AppCoffeeMug.webp";
import AppCoffeeMugModel from "./AppCoffeeMugModel";
import "./AppCoffeeMug.scss";

export default function AppCoffeeMug() {
    const vm = new AppCoffeeMugModel();
    const { t } = useTranslation();
    return (
        <div className={vm.className}>
            <div className={vm.contentClassName}>
                <img
                    className="lan-appcoffeemug__content__animation"
                    alt={t(translationKeys.appCoffeeMug.alt)}
                    src={animation}
                />
                <div className={vm.textClassName}>{vm.text}</div>
            </div>
        </div>
    );
}
